/**
 * 统计相关接口
 * 接口文档 http://47.110.15.13:8020/pages/viewpage.action?pageId=6291626
 * @type {{}}
 */
const project = {
  // 添加项目
  addOrUpdateProject: '/api/ProjectList/AddOrUpdateProject',
  // 获取项目信息和项目图片
  getCurrentProject: '/api/Project/GetCurrentProject',
  // 获取项目创建者数据
  getUnassignedInviteeUsers: '/api/AccountManagement/GetUnassginedInviteeUsers',
  // 修改项目信息
  updateCurrentProject: '/api/Project/UpdateCurrentProject',
  // 用户管理-获取用户项目列表
  getUserManagedProjects: '/api/AccountManagement/GetUserManagedProjects',
  // 删除项目
  deleteProject: '/api/ProjectList/DeleteProject',
}

Object.freeze(project)
export default project
